import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'

export default {
  getYearsAndSubgroups(organisationId: number) {
    const appStore = useAppStore()

    return axios.get<App.Http.Resources.MyFJV2.GroupResource[], App.Http.Resources.MyFJV2.GroupResource[]>(`${appStore.daraApiBaseUrl}/organisations/${organisationId}/years-and-subgroups`)
  },
}
